module.exports = __webpack_public_path__ + "public/SiteIcons/map-pin-large.png?7602a384";